module.exports = __webpack_public_path__ + "img/export-clips.75d61241.png";